import { useMatch } from 'react-router-dom';

import routes from 'core/routes';

const useFieldManagerParams = (): string => {
  const match = useMatch(routes.dashboard.settings.objects.details.fieldManager.toString());
  const { moduleName } = match?.params as { moduleName: string };

  return moduleName;
};

export default useFieldManagerParams;
